import { FormControlLabel, Radio, Text } from "designSystem/index";
import React, { ChangeEvent, useState } from "react";
import RadioGroup from "designSystem/components/radio/RadioGroup";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	const [product, setProduct] = useState("food");

	const onProduct = (event: object, value: string) => {
		setProduct(value);
	};

	const [bool, setBool] = useState(true);

	const onBoolean = (event: object, value: boolean) => {
		setBool(value);
	};

	const options = [
		{ name: "Food", value: "food" },
		{ name: "Style", value: "style" },
		{ name: "Material", value: "material", helperText: "Test helper text" },
		{ name: "Test Product", value: "testproduct", disabled: true, helperText: "Disabled helper text" },
	];

	const invalidOptions = [
		{ name: "Food", value: "food", invalid: true },
		{ name: "Style", value: "style", invalid: true },
		{ name: "Material", value: "material", helperText: "Test helper text", invalid: true },
		{ name: "Test Product", value: "testproduct", invalid: true },
	];

	const boolOptions = [
		{ name: "True", value: true },
		{ name: "False", value: false },
	];

	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="Normal" />
			<Text semiBold text="Invalid" />
			<Text semiBold text="Boolean" />
			<RadioGroup
				aria-label="product"
				name="Radio Group"
				onChange={onProduct}
				options={options}
				value={product}
			/>
			<RadioGroup
				aria-label="product"
				invalidText="This one is not valid."
				name="Radio Group With An Extremely Long Name That Will Have to Wrap At Least Once"
				onChange={onProduct}
				options={invalidOptions}
				value={product}
			/>
			<RadioGroup
				aria-label="boolean"
				name="Boolean Radio Group"
				onChange={onBoolean}
				options={boolOptions}
				value={bool}
			/>
		</CssColumnGrid>
	);
};
